import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from '@material-ui/core/Grid';

import PercentProductCardV2 from "./components/PercentProductCardV2/PercentProductCardV2";
import SelectAspectsV2 from "./components/SelectAspectsV2";
import InfoCard from "../../DynamicStep/components/InfoCard";

import styles from "./styles";

const INFOS = {
  "ecologically-sustainable":
      "„Ökologisch nachhaltig“ bezeichnet eine nachhaltige Investition gemäss der Taxonomieverordnung. Solch eine Investition leistet u.a. einen wesentlichen Beitrag zur Verwirklichung eines oder mehrerer Umweltziele.",
  "esg": "„ESG“ (Environmental Social Governance) bezeichnet eine nachhaltige Investition gemäss der Offenlegungsverordnung. Sie trägt zur Erreichung eines Umweltziels oder eines sozialen Ziels bei und investiert in Unternehmen, die Verfahrensweisen einer guten Unternehmensführung anwenden.",
  "pai": "„PAI“ (Principal Adverse Impacts) bezeichnet Investitionen, welche die wichtigsten nachteiligen Auswirkungen auf Nachhaltigkeitsfaktoren beachten wie z.B.: Treibhausgasemissionen, Biodiversitätsverlust, Wasserverbrauch, Abfall sowie soziale und arbeitsrechtliche Belange.",
};

const SettingsProfileV2 = (props) => {

  const {
    classes,
    questions: [percent, aspects],
    onAnswerChange,
    dataService
  } = props;

  const current = dataService.step;

  aspects.optional = percent.answer === 0;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.categoryName}>{current.category}</Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <InfoCard uid={current.category} isNewDesign info_text={INFOS[current.uid]} />
              </Grid>
              <Grid item xs={12}>
                <PercentProductCardV2 onAnswerChange={onAnswerChange} question={percent} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <SelectAspectsV2
              onAnswerChange={onAnswerChange}
              question={aspects}
              dataService={dataService}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};


export default withStyles(styles)(SettingsProfileV2);
